/**
 * List of poll answers colors in the app
 */
const pollColorsList = [
    '#970C2D',
    '#EF476F',
    '#FFD166',
    '#F5AB00',
    '#ED7D3A',
    '#8F6400',
    '#06D6A0',
    '#659157',
    '#863197',
    '#AC30C5',
    '#5AD2F4',
    '#4D8593',
    '#118AB2',
    '#073B4C',
    '#8E8E93',
];

/**
 * Get poll answer color
 *
 * @param {number} i Poll list index number
 * @returns {string} Hex color
 */
function getPollAnswerColor(i) {
    return pollColorsList[i % pollColorsList.length];
}

export {
    pollColorsList,
    getPollAnswerColor,
};